export default __webpack_public_path__ + "assets/4433aaeeeef61dbc803b529d5695f69f-sticker.png";